export const canChangePlan = (selectedSub: Subscription) => {
  const isAa = !!selectedSub?.aa_rcp;
  const isEssential = !selectedSub?.rcp && !isAa;

  return selectedSub?.status === 'active' && isEssential;
};
